import zorg1 from '../assets/imagesset/zorg1.png'
import zorg2 from '../assets/imagesset/zorg2.png'
import zorg3 from '../assets/imagesset/zorg3.png'
import samen1 from '../assets/imagesset/samen1.png'
import samen2 from '../assets/imagesset/samen2.png'
import samen3 from '../assets/imagesset/samen3.png'
import conf1 from '../assets/imagesset/conf1.png'
import conf2 from '../assets/imagesset/conf2.png'
import conf3 from '../assets/imagesset/conf3.png'
import daadkracht1 from '../assets/imagesset/daadkracht1.png'
import daadkracht2 from '../assets/imagesset/daadkracht2.png'
import daadkracht3 from '../assets/imagesset/daadkracht3.png'
import daadkracht4 from '../assets/imagesset/daadkracht4.png'
import duurzaam1 from '../assets/imagesset/duurzaam1.png'
import duurzaam2 from '../assets/imagesset/duurzaam2.png'
import duurzaam3 from '../assets/imagesset/duurzaam3.png'
import erken1 from '../assets/imagesset/erken1.png'
import erken2 from '../assets/imagesset/erken2.png'
import erken3 from '../assets/imagesset/erken3.png'
import gelijk1 from '../assets/imagesset/gelijk1.png'
import gelijk2 from '../assets/imagesset/gelijk2.png'
import gelijk3 from '../assets/imagesset/gelijk3.png'
import gelijk4 from '../assets/imagesset/gelijk4.png'
import macht1 from '../assets/imagesset/macht1.png'
import macht2 from '../assets/imagesset/macht2.png'
import macht3 from '../assets/imagesset/macht3.png'
import prestatie1 from '../assets/imagesset/prestatie1.png'
import prestatie2 from '../assets/imagesset/prestatie2.png'
import prestatie3 from '../assets/imagesset/prestatie3.png'
import prestatie4 from '../assets/imagesset/prestatie4.png'
import innovatie1 from '../assets/imagesset/innovatie1.png'
import innovatie2 from '../assets/imagesset/innovatie2.png'
import innovatie3 from '../assets/imagesset/innovatie3.png'
import integriteit1 from '../assets/imagesset/integriteit1.png'
import integriteit2 from '../assets/imagesset/integriteit2.png'
import integriteit3 from '../assets/imagesset/integriteit3.png'
import voorspelbaar1 from '../assets/imagesset/voorspeelbaar1.png'
import voorspelbaar2 from '../assets/imagesset/voorspeelbaar2.png'
import voorspelbaar3 from '../assets/imagesset/voorspeelbaar3.png'
import zelfontplooi1 from '../assets/imagesset/zelfontplooi1.png'
import zelfontplooi2 from '../assets/imagesset/zelfontplooi2.png'
import zelfontplooi3 from '../assets/imagesset/zelfontplooi3.png'
import zelfsturing1 from '../assets/imagesset/zelfsturing1.png'
import zelfsturing2 from '../assets/imagesset/zelfsturing2.png'
import zelfsturing3 from '../assets/imagesset/zelfsturing3.png'
// FIMXE png2png
import { info, logException } from '../services/sentryLogger'

export const ImgMap: Record<string, string> = {
    zorg1,
    zorg2,
    zorg3,
    conf1,
    conf2,
    conf3,
    daadkracht1,
    daadkracht2,
    daadkracht3,
    daadkracht4,
    duurzaam1,
    duurzaam2,
    duurzaam3,
    erken1,
    erken2,
    erken3,
    gelijk1,
    gelijk2,
    gelijk3,
    gelijk4,
    macht1,
    macht2,
    macht3,
    prestatie1,
    prestatie2,
    prestatie3,
    prestatie4,
    innovatie1,
    innovatie2,
    innovatie3,
    integriteit1,
    integriteit2,
    integriteit3,
    voorspelbaar1,
    voorspelbaar2,
    voorspelbaar3,
    zelfontplooi1,
    zelfontplooi2,
    zelfontplooi3,
    zelfsturing1,
    zelfsturing2,
    zelfsturing3,
    samen1,
    samen2,
    samen3,
}

info('ImgMap', Object.keys(ImgMap).length)

export const cacheImages = async (srcArray: string[]) => {
    // const srcArray = ['https://via.placeholder.com/150', 'https://via.placeholder.com/150', 'https://via.placeholder.com/150']
    const promises = srcArray.map(
        (src) =>
            new Promise((resolve, reject) => {
                const img = new Image()
                img.src = src
                img.onload = resolve
                img.onerror = reject
            })
    )
    return await Promise.all(promises)
}

cacheImages(Object.values(ImgMap)).then((imgs: any[]) =>
    info(imgs.length + ' image(s) cached')
).catch(e => logException('cacheImages', '', e))
